class LangSelector extends HHBaseElement {
  constructor() {
    super();

    this.countrySelector = this.querySelector('.js-country-selector')

    // The country the page is currently rendered in, so re-picking it is a no-op.
    this.currentIso = (this.countrySelector
      ?.querySelector('[aria-selected="true"]')
      ?.dataset?.isoCode || '').toUpperCase()

    // custom-dropdown.js dispatches countryChanged from selectOption(), which covers
    // click, Enter/Space and select-on-blur. There is no Apply button in this design,
    // so a real change navigates straight away.
    document.addEventListener('countryChanged', this.onCountryChanged.bind(this))
  }

  connectedCallback() {
    this._setupFocusTrap(this.closest('modal-dialog'))
  }

  onCountryChanged() {
    const option = this.countrySelector?.querySelector('[aria-selected="true"]')
    const iso = (option?.dataset?.isoCode || '').toUpperCase()

    // Guard against select-on-blur: closing the dropdown without moving the highlight
    // re-selects the current country, and reloading the same market is pointless.
    if (!iso || iso === this.currentIso) return

    this.submit(option)
  }

  // Keep the current language if the destination market offers it, otherwise use that
  // market's first configured language.
  getLanguageForCountry(option) {
    const languages = (option?.dataset?.languages || 'en')
      .split(',')
      .map((lang) => lang.trim().toLowerCase())
      .filter(Boolean)

    if (languages.length === 0) return 'en'

    const current = (window.Shopify?.locale || '').toLowerCase()
    if (current && languages.includes(current)) return current

    return languages[0]
  }

  submit(countryOption) {
    const option = countryOption
      || this.countrySelector?.querySelector('[aria-selected="true"]')
    const countryUrl = option?.dataset?.href
    if (!countryUrl) return

    const language = this.getLanguageForCountry(option)
    const iso = (option.dataset?.isoCode || '').toUpperCase()

    this._syncOrbe(iso, language)

    window.location.href = this._withCountryParams(
      countryUrl.replace('en-', `${language}-`),
      iso
    )
  }

  // BM-1371: Orbe geolocates the visitor on every page load and re-opens its
  // "shop your local store" modal unless mdApp_countryCodeDomain marks the country
  // as a deliberate choice. Picking a country here never told Orbe anything, so the
  // selection was overridden on the next page view. Mirrors therow-theme#603.
  _syncOrbe(countryCode, localeCode) {
    if (typeof orbito === 'undefined' || !countryCode) return

    const domain = typeof orbito.getCountryDomain === 'function'
      ? orbito.getCountryDomain() || window.location.hostname
      : window.location.hostname
    const maxAge = 86400 * (orbito.cookies?.modal_reappear || 60)

    const write = (name, value) => {
      document.cookie = `${name}=${value}; domain=${domain}; path=/; max-age=${maxAge}`
    }

    write('mdApp_countryCodeDomain', countryCode)
    if (localeCode) write('mdApp_showRecommendationLang', localeCode)
  }

  // Orbe also reads the country off the landing URL. Only replace `oc` if it is
  // already there; adding it where Orbe did not put it changes its redirect handling.
  _withCountryParams(url, countryCode) {
    if (!countryCode) return url

    try {
      const destination = new URL(url, window.location.origin)
      destination.searchParams.set('country', countryCode)
      if (destination.searchParams.has('oc')) {
        destination.searchParams.set('oc', countryCode)
      }
      return destination.toString()
    } catch (e) {
      return url
    }
  }
}

window.customElements.define('lang-selector', LangSelector);
